import React from 'react'
import ReactDOM from 'react-dom/client'
import { QueryClientProvider } from '@tanstack/react-query'
import App from './App.tsx'
import { queryClient } from '@lib/queryClient'
import { analyticsService } from '@lib/analytics/posthog.service'
import ErrorBoundary from '@components/web/ErrorBoundary'
import './styles/index.css'

analyticsService.init()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </ErrorBoundary>
  </React.StrictMode>,
)

